/* eslint-disable max-params, @typescript-eslint/no-explicit-any */
import assert from '../core/util/assert';
import captureException from '../core/util/captureException';

if (APP_ENV.GTM_ID) {
    ((
        w: any,
        d: Document,
        s: string,
        l: string,
        i: string,
        a?: string,
        p?: string
    ) => {
        // eslint-disable-next-line no-param-reassign
        w[l] = w[l] || [];
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        // eslint-disable-next-line prefer-destructuring
        const f = d.getElementsByTagName(s)[0];
        const j = d.createElement(s);
        const dl = l !== 'dataLayer' ? `&l=${l}` : '';

        assert(j instanceof HTMLScriptElement, 'script element is required.');
        j.async = true;
        let src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;

        if (a) src += `&gtm_auth=${a}`;
        if (p) src += `&gtm_preview=${p}`;

        j.src += src;

        j.onerror = () => {
            captureException(new Error('Failed to load Google Tag Manager'));
        };

        assert(f.parentNode, 'f.parentNode is required.');
        f.parentNode.insertBefore(j, f);
    })(
        window,
        document,
        'script',
        'dataLayer',
        APP_ENV.GTM_ID,
        APP_ENV.GTM_AUTH,
        APP_ENV.GTM_PREVIEW
    );
}
export {};
